const formatContainerClasses = 'h-100 w-100 position-absolute overflow-auto d-flex flex-column';

export { formatContainerClasses };
